<template>
  <div id="loading" ref="" v-if="show" >
    <img src="~assets/img/loading.png" alt="">
  </div>
</template>

<script>
import router from '../../router'

export default {
  name: 'toast',
  props: {
    show: false,
  },
  // watch:{
  //   showLoading(curVal){
  //     console.log(11)
  //     this.show=curVal;
  //   },
  // },
  data() {
    return {
      type: '',
    }
  },
  mounted() {

  },
  methods: {
    close() {
      this.remove()
    },
    toSelf() {
      this.close()
      router.push({ path: '/' })
    },
  },
}
</script>

<style scoped>
#loading {
    width: 1rem;
    height: 1rem;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    background: #000;
    opacity: 0.8;
    border-radius: 5px;
}
img {
    width: 0.4rem;
    height: 0.4rem;
    margin-top: 0.3rem;
    margin-left: 0.3rem;
    animation: rotate360 1s linear infinite;
}
@keyframes rotate360 {
  0% {
      transform: rotate(0deg)
  }
  100% {
      transform: rotate(360deg)
  }
}
</style>
